import { Box, xcss } from '@atlaskit/primitives';
import React, { type ReactNode } from 'react';

const shellStyles = xcss({
  paddingBlock: 'space.075',
});

/**
 * Wrapper for drilldown menu content, providing consistent padding and any other shared styles.
 *
 * Auto-applied by `NestedPopup` to all `DrilldownMenu.content`.
 */
const MenuContentShell = ({ children }: { children: ReactNode }) => {
  return (
    <Box xcss={shellStyles} testId="menu-content-shell">
      {children}
    </Box>
  );
};

export default MenuContentShell;
